import { render } from "./PatientTherapyForm.vue?vue&type=template&id=d2311aea"
import script from "./PatientTherapyForm.vue?vue&type=script&lang=js"
export * from "./PatientTherapyForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__